'use strict';

const { COLORS } = require('../config/constants');

function roundedRectPath(ctx, x, y, width, height, radius) {
  const r = Math.min(radius, width / 2, height / 2);
  ctx.beginPath();
  ctx.moveTo(x + r, y);
  ctx.lineTo(x + width - r, y);
  ctx.quadraticCurveTo(x + width, y, x + width, y + r);
  ctx.lineTo(x + width, y + height - r);
  ctx.quadraticCurveTo(x + width, y + height, x + width - r, y + height);
  ctx.lineTo(x + r, y + height);
  ctx.quadraticCurveTo(x, y + height, x, y + height - r);
  ctx.lineTo(x, y + r);
  ctx.quadraticCurveTo(x, y, x + r, y);
  ctx.closePath();
}

function drawPanel(ctx, x, y, width, height, options) {
  const config = options || {};
  ctx.save();
  roundedRectPath(ctx, x, y, width, height, config.radius || 28);
  ctx.fillStyle = config.fill || COLORS.panel;
  ctx.fill();
  ctx.strokeStyle = config.stroke || 'rgba(70, 230, 255, 0.38)';
  ctx.lineWidth = config.lineWidth || 2;
  ctx.stroke();
  ctx.restore();
}

function drawText(ctx, text, x, y, size, color, align, weight) {
  ctx.save();
  ctx.font = `${weight || 'normal'} ${size}px sans-serif`;
  ctx.fillStyle = color || COLORS.text;
  ctx.textAlign = align || 'center';
  ctx.textBaseline = 'middle';
  ctx.fillText(String(text), x, y);
  ctx.restore();
}

function drawGlowText(ctx, text, x, y, size, color) {
  ctx.save();
  ctx.shadowColor = color || COLORS.cyan;
  ctx.shadowBlur = 22;
  drawText(ctx, text, x, y, size, color || COLORS.cyan, 'center', 'bold');
  ctx.restore();
}

function drawLock(ctx, x, y, scale) {
  const s = scale || 1;
  ctx.save();
  ctx.strokeStyle = COLORS.muted;
  ctx.fillStyle = 'rgba(145, 164, 201, 0.22)';
  ctx.lineWidth = 4 * s;
  ctx.beginPath();
  ctx.arc(x, y - 8 * s, 12 * s, Math.PI, 0);
  ctx.stroke();
  roundedRectPath(ctx, x - 18 * s, y - 7 * s, 36 * s, 30 * s, 5 * s);
  ctx.fill();
  ctx.stroke();
  ctx.restore();
}

function drawRadianceSparkles(ctx, x, y, scale, radiance) {
  if (!radiance || !radiance.sparkles || !radiance.sparkles.length) return;
  const s = scale || 1;
  ctx.save();
  ctx.translate(x, y);
  ctx.globalCompositeOperation = 'lighter';
  radiance.sparkles.forEach((sparkle) => {
    ctx.globalAlpha = sparkle.alpha;
    ctx.fillStyle = radiance.highlightColor || '#ffffff';
    ctx.shadowColor = radiance.glowColor || '#ffffff';
    ctx.shadowBlur = 10 * s;
    const px = sparkle.x * s;
    const py = sparkle.y * s;
    const radius = sparkle.radius * s;
    ctx.beginPath();
    ctx.moveTo(px, py - radius * 2.2);
    ctx.lineTo(px + radius * 0.55, py - radius * 0.55);
    ctx.lineTo(px + radius * 2.2, py);
    ctx.lineTo(px + radius * 0.55, py + radius * 0.55);
    ctx.lineTo(px, py + radius * 2.2);
    ctx.lineTo(px - radius * 0.55, py + radius * 0.55);
    ctx.lineTo(px - radius * 2.2, py);
    ctx.lineTo(px - radius * 0.55, py - radius * 0.55);
    ctx.closePath();
    ctx.fill();
  });
  ctx.restore();
}

function drawPlane(ctx, x, y, scale, color, radiance) {
  const s = scale || 1;
  const body = (radiance && radiance.color) || color || COLORS.cyan;
  ctx.save();
  ctx.translate(x, y);
  ctx.shadowColor = (radiance && radiance.glowColor) || body;
  ctx.shadowBlur = ((radiance && radiance.glowBlur) || 20) * s;
  if (radiance) ctx.globalAlpha = radiance.glowAlpha;
  ctx.fillStyle = body;
  ctx.beginPath();
  ctx.moveTo(0, -48 * s);
  ctx.lineTo(19 * s, -8 * s);
  ctx.lineTo(48 * s, 16 * s);
  ctx.lineTo(22 * s, 22 * s);
  ctx.lineTo(14 * s, 43 * s);
  ctx.lineTo(0, 33 * s);
  ctx.lineTo(-14 * s, 43 * s);
  ctx.lineTo(-22 * s, 22 * s);
  ctx.lineTo(-48 * s, 16 * s);
  ctx.lineTo(-19 * s, -8 * s);
  ctx.closePath();
  ctx.fill();
  ctx.globalAlpha = 1;
  if (radiance) {
    ctx.strokeStyle = radiance.highlightColor;
    ctx.lineWidth = (1.4 + radiance.progress * 2.4) * s;
    ctx.stroke();
  }
  ctx.fillStyle = (radiance && radiance.highlightColor) || '#e9fdff';
  ctx.beginPath();
  ctx.ellipse(0, -12 * s, 8 * s, 18 * s, 0, 0, Math.PI * 2);
  ctx.fill();
  ctx.restore();
  drawRadianceSparkles(ctx, x, y, s, radiance);
}

module.exports = {
  roundedRectPath,
  drawPanel,
  drawText,
  drawGlowText,
  drawLock,
  drawPlane,
  drawRadianceSparkles
};
